export default __webpack_public_path__ + "static/logo_rst-458de259df5ca35a7ef658780824c106.png";